module.exports = __webpack_public_path__ + "static/black-and-white-coins-c3584c51b29b70bdd5d425084788a534.jpg";